module.exports = __webpack_public_path__ + "media/icons/icon_per-05275ffd.png";